import React from 'react';
import SetPasswordContainer from '../components/setPassword.container';

const SetPasswordPage: React.FC = () => <SetPasswordContainer />;

export default SetPasswordPage;
